export enum PAGE_TITLE {
  HOME = '',
  DASHBOARD = 'Dashboard',
  USSD_SESSION = 'USSD Session',
  USSD_PUSH = 'USSD Push',
  WALLET = 'Wallet',
  USER_MANAGEMENT = 'Sub-accounts',
  USSD = 'USSD',
  WAP = 'WAP',
  VOICE = 'Voice',
  USSD_EDITOR = 'Editor',
  AIRTIME_AND_DATA = 'Top-up & Data',
  ACCOUNT_TRANSFERS = 'Account Transfers',
  SMS = 'SMS',
  PAYOUT = 'Payout',
  OPERATOR_LOOKUP = 'Operator Lookup',
  ONDEMAND = 'Ondemand',
  MERCHANT_PAYMENT = 'Merchant Payment',
  CUSTOMER_VALIDATION = 'KYC',
  CUSTOMER_AUTHENTICATION = 'Customer Authentication',

  CUSTOMER_ENROLLMENT = 'Customer Enrollment',
  PRODUCTS_AND_SERVICES = 'Products and services'
}

export enum SERVICE_CATEGORY_TITLE {
  ACCESS = 'Access',
  VALUE = 'Value',
  IDENTITY = 'Identity'
}

export enum SERVICE_SUBPAGE_TITLE {
  BILLING = 'Billing',
  REPORTS = 'Reports',
  APPS = 'Apps'
}
